import { createContext, useContext, type ReactNode } from "react"
import UserContext from "./context/UserContext"
import { Spinner } from "./components/loading/Spinner"

interface LoadingContextType {
    loading: boolean
    setLoading: (loading: boolean) => void
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

export function LoadingProvider({ children }: { children: ReactNode }) {
    const { isLoading, setIsLoading } = useContext(UserContext);
    return (
        <LoadingContext.Provider value={{ loading: isLoading, setLoading: setIsLoading }}>
            {children}
            {isLoading && (
                <div
                    id="loader-fallback"
                    className="flex h-screen w-full items-center justify-center z-[9999]"
                >
                    <Spinner />
                </div>
            )}
        </LoadingContext.Provider>
    )
}

export function useLoadingContext() {
    const context = useContext(LoadingContext)
    if (context === undefined) {
        throw new Error("useLoadingContext must be used within a LoadingProvider")
    }
    return context
}

